// Copyright (c) 2020 Deere & Company

import './index.scss';

import AuthenticatedPage from '../../common/components/authenticated-page';
import PriorityReservationInquiry from './priority-reservation-inquiry';
import React from 'react';

function PriorityReservationInquiryPage () {

    return (
        <AuthenticatedPage className="atp-page atp-priority-reservation-inquiry-page">
            <PriorityReservationInquiry />
        </AuthenticatedPage>
    );

}
PriorityReservationInquiryPage.displayNAme = 'PriorityReservationInquiryPage';

export default PriorityReservationInquiryPage;
